import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeCurrencyList } from './normalize';

export const fetchCurrencyList = createProvider(api.fetchCurrencyList)
  .andThen((res) => normalizeCurrencyList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
